import styled from "styled-components";
import Label from "./atoms/Label";

const ListItemLabel = styled(Label)`
    display: block;
    padding-bottom: 8px;
    margin: 0;
`;

export default ListItemLabel;